import { render, staticRenderFns } from "./starProduct.vue?vue&type=template&id=d54edfc8&scoped=true&"
import script from "./starProduct.vue?vue&type=script&lang=js&"
export * from "./starProduct.vue?vue&type=script&lang=js&"
import style0 from "./starProduct.vue?vue&type=style&index=0&id=d54edfc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54edfc8",
  null
  
)

export default component.exports